import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
export const SkeletonText = () => /*#__PURE__*/_jsx(View, {
  backgroundColor: "border-core-subtle",
  blockSize: "0.8em",
  borderRadius: "full",
  "data-test-id": "loading",
  display: "inline-block",
  inlineSize: "6em"
});